import Share from 'ninelines-sharing';

$('[data-social]').on('click', (event) => {
	let $button = $(event.currentTarget);
	let url = location.origin;
	let page = location.pathname.slice(1);
	let description = $('meta[name="description"]').attr('content');

	if (page) {
		url += `/share.php?page=${encodeURIComponent(page)}`;
	}

	event.preventDefault();
	$button.trigger('blur');

	switch ($button.data('social')) {
		case 'facebook':
			Share.facebook(url);
			break;

		case 'vk':
			Share.vk(url);
			break;

		case 'twitter':
			Share.openWindow(`${Share.getUrl('twitter', url)}&text=${encodeURIComponent(description)}`);
			break;

		// no default
	}
});
